import { render, staticRenderFns } from "./search-input.vue?vue&type=template&id=27ceadc6&scoped=true&"
import script from "./search-input.vue?vue&type=script&lang=js&"
export * from "./search-input.vue?vue&type=script&lang=js&"
import style0 from "./search-input.vue?vue&type=style&index=0&id=27ceadc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ceadc6",
  null
  
)

export default component.exports